export default __webpack_public_path__ + "static/ngo_donate-aa0f13810906e156ff3c04bcca36dbb8.jpg";